import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var Error404 = /*#__PURE__*/function (_Vue) {
  _inherits(Error404, _Vue);

  var _super = _createSuper(Error404);

  function Error404() {
    var _this;

    _classCallCheck(this, Error404);

    _this = _super.apply(this, arguments);
    _this.message = '这个页面飞走了......';
    return _this;
  }

  _createClass(Error404, [{
    key: "goHome",
    value: function goHome() {
      this.$router.push({
        path: '/'
      });
    }
  }]);

  return Error404;
}(Vue);

Error404 = __decorate([Component], Error404);
export default Error404;